import React, { useContext, useState } from "react";
import { Input } from "antd";
import Loader from "../../components/loader";
import { APIProviderContext } from "../../components/api";

function ResetPage() {
  const { apiAction } = useContext(APIProviderContext);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  async function handleReset(e) {
    e.preventDefault();
    if (!password) return;
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    try {
      const data = await apiAction("POST", "task/reset", { password });
      setSuccessMessage(data?.response || "Reset complete");
    } catch (err) {
      setErrorMessage(err?.response?.data?.response || "Reset failed");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="flex flex-col min-h-screen w-full items-center p-4 py-10">
      {/* <img src="/images/mosaic-image2.avif" className="w-[180px] h-auto mb-10" /> */}
      <h1 className="text-3xl font-bold mb-4 px-4 text-center">Reset</h1>
      <form onSubmit={handleReset} className="w-full p-4 mx-auto max-w-[400px] flex flex-col gap-4">
        <div>
          <label className="block text-[16px] mb-2">Password</label>
          <Input
            placeholder="Enter password"
            value={password}
            className="bg-blue-700 border-blue-600 text-white placeholder-blue-300"
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        <button
          type="submit"
          disabled={loading || !password}
          className="w-full bg-[#0D72FF] disabled:bg-[#1c447a] text-white py-2 flex items-center justify-center px-6 h-12 font-medium hover:bg-[#0d5ecf] transition-colors mt-2 rounded-lg"
        >
          {loading ? <Loader /> : "Send reset request"}
        </button>
        {successMessage ? (
          <div className="text-green-300 text-[16px]">{successMessage}</div>
        ) : null}
        {errorMessage ? (
          <div className="text-red-300 text-[16px]">{errorMessage}</div>
        ) : null}
      </form>
    </div>
  );
}

export default ResetPage;